import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { StepperDiscaAfiliado } from "./StepperDiscaAfiliado";
import { NuevaSolicStep4 } from "./NuevaSolicStep4";
import { NuevaSolicStep3 } from "./NuevaSolicStep3";
import { NuevaSolicStep2 } from "./NuevaSolicStep2";
import { NuevaSolicStep1 } from "./NuevaSolicStep1";
import { ESTADISTICAS_OSPEDYC } from "../../../../utils/constants";
import { cargarEstadisticas } from "../../../../actions/miOspedyc/estadisticasMiOspedyc";
import LoadingBeforeViewData from "../../../compartidos/LoadingBeforeViewData";
import AfiliadoDiscapacidadService from "../../../../services/AfiliadoDiscapacidadService";
import { fetchCertificados } from "../../../../actions/certificados";
import { changeStepDiscapacidadAutoG, clearReducerDiscapacidadAutoG } from "../../../../actions/webAfiliado/afiliadoDiscapacidadActions";
import { getCredenciales } from "../../../../actions/webAfiliado/afiliadoVariosAction";
import { STEPPER_INTEGRACION_AUTO_G } from "../../../Discapacidad/data/constants";
import { startAlerta } from "../../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold",
        marginBottom: "1rem"
    },
}));


export const NuevaSolicitud = (props) => {
    const location=useLocation()
    const classes = useStyles();
    const dispatch = useDispatch()
    
    const { idAfiliado } = useSelector(state => state.auth)
    const { credenciales } = useSelector(state => state.afiliadoVarios)
    const { stepDiscapacidad, solicitudSeleccionada } = useSelector(state => state.afiliadoDiscapacidad)

    const [datosContacto, setDatosContacto] = useState(null)

    // const handleChangeAfiliadoDisca=(e)=>{
    //     setearVariosValores({
    //         idAfiliado:e.target.value,
    //         fechaNacimiento: credenciales.find(el=>parseInt(el.idAfiliado) === parseInt(e.target.value))?.fechaNacimiento
    //     })
    // }

    const handleGetDataContacto = async () => {
        try {
            dispatch(startSpinner())
            const result = await AfiliadoDiscapacidadService.getDataContacto(idAfiliado)
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                setDatosContacto({
                    telefono: body.domiciliosAfiliados.telefono,
                    celular: body.domiciliosAfiliados.celular,
                    mail: body.domiciliosAfiliados.mail
                })
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error al seleccionar al afiliado. Intente nuevamente", "error"))
            }
            console.log("Error al seleccionar al afiliado", error)
        }
    }

    const handleChangeStep=(step)=>{
        dispatch(changeStepDiscapacidadAutoG(step))
    }

    useEffect(() => {
        dispatch(getCredenciales())
        if(props.location.state?.from !== "/afiliado/discapacidad/mis-solicitudes")
            dispatch(clearReducerDiscapacidadAutoG())
        else
            handleChangeStep(STEPPER_INTEGRACION_AUTO_G.DETALLES_ORDEN)
    }, [])

    useEffect(() => {
        if(idAfiliado)  dispatch(fetchCertificados(idAfiliado));
    } , [idAfiliado])
    
    useEffect(() => {
        dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.DISCAPACIDAD))
    }, [])

    useEffect(()=>{
        if(idAfiliado === ""){
            handleChangeStep(STEPPER_INTEGRACION_AUTO_G.BUSCAR_AFILIADO)
        }
    }, [location.pathname])

    if (credenciales === null) {
        return <LoadingBeforeViewData />
    }

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Typography align="center" variant="h4" color="primary" className={classes.title}>Nueva Solicitud</Typography>
                <StepperDiscaAfiliado step={stepDiscapacidad}/>
                {
                    stepDiscapacidad === 0 &&                    
                    <NuevaSolicStep1 
                        idAfiliado={idAfiliado} 
                        credenciales={credenciales} 
                        datosContacto={datosContacto}
                        handleChangeStep={handleChangeStep}
                        handleGetDataContacto={handleGetDataContacto}
                        solicitudSeleccionada={solicitudSeleccionada}
                    />
                }
                {
                    stepDiscapacidad === 1 &&
                    <NuevaSolicStep2 
                        idAfiliado={idAfiliado}
                        handleChangeStep={handleChangeStep} 
                    />
                }
                {
                    stepDiscapacidad === 2 &&
                    <NuevaSolicStep3 
                        handleChangeStep={handleChangeStep}
                        solicitudSeleccionada={solicitudSeleccionada}
                    />
                }
                {
                    stepDiscapacidad === 3 &&
                    <NuevaSolicStep4
                        idAfiliado={idAfiliado}
                        credenciales={credenciales}
                        datosContacto={datosContacto}
                        handleChangeStep={handleChangeStep}

                    />
                }

                {/* <Button onClick={() => dispatch(changeStepTurnos(stepTurno + 1))}>Cambiar</Button> */}
            </Container>
        </div>
    );
};
